import React from 'react'

// Minimal markdown rendering for assistant answers (same approach as the
// admin ChatAssistant): **bold** and line breaks. No external dependency,
// no HTML injection — everything stays plain React nodes.
const renderInline = (text: string, keyPrefix: string): React.ReactNode[] => {
    const parts = text.split(/(\*\*[^*]+\*\*)/g)
    return parts.map((part, index) => {
        if (part.startsWith('**') && part.endsWith('**')) {
            return <strong key={`${keyPrefix}-${index}`}>{part.slice(2, -2)}</strong>
        }
        return <React.Fragment key={`${keyPrefix}-${index}`}>{part}</React.Fragment>
    })
}

export const renderAssistantMarkdown = (text?: string): React.ReactNode => {
    if (!text) return null
    return text.split('\n').map((line, index) => (
        <React.Fragment key={index}>
            {index > 0 && <br />}
            {renderInline(line, `line-${index}`)}
        </React.Fragment>
    ))
}
